import React from 'react';

export default function HeroMF2026({ translations }) {
  return (
    <section className="relative flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[720px] lg:min-h-[760px]">
      <img
        className="absolute inset-0 h-full w-full object-cover object-[52%_34%] sm:object-[52%_38%] lg:object-[50%_42%]"
        src={translations?.backgroundImage}
        alt=""
        aria-hidden="true"
      />

      <div className="absolute inset-0 bg-[#061f23]/55 md:bg-[#061f23]/45" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20 md:bg-gradient-to-r md:from-black/35 md:via-black/10 md:to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-[1100px] translate-y-4 px-5 pb-16 pt-20 text-center md:translate-y-8 md:px-10 md:pb-24 md:pt-28 md:text-left lg:px-12 lg:pb-28 lg:pt-32">
        <h1
          className="mx-auto mb-10 pt-16 pb-6 max-w-5xl text-xl md:text-2xl lg:text-3xl font-normal leading-tight text-white md:mx-0 md:mb-24 lg:mb-28"
          dangerouslySetInnerHTML={{ __html: translations?.title }}
        />

        <h2
          className="mx-auto mb-4 pt-10 max-w-5xl text-[1.25rem] font-extrabold leading-snug text-white md:mx-0 md:mb-4 md:text-[1.45rem] lg:text-[1.6rem]"
          dangerouslySetInnerHTML={{ __html: translations?.subtitle }}
        />

        <p
          className="mx-auto max-w-5xl text-[1rem] leading-relaxed text-white md:mx-0 md:text-[1.1rem] lg:text-[1.2rem]"
          dangerouslySetInnerHTML={{ __html: translations?.description }}
        />

        <a
          href="#signup"
          className="mt-5 inline-flex w-full items-center justify-center rounded-full bg-swiss-300 px-6 py-3.5 text-base font-bold text-white shadow-sm transition hover:bg-swiss-300/95 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#2D5F5F] sm:w-auto md:mt-8 md:px-8">
          {translations?.buttonText}
        </a>
      </div>
    </section>
  );
}
